import Marquee from "react-fast-marquee";

const ITEMS = ["Fuel Oil", "MHO", "Diesel", "Crude Oil", "Gas Oil", "Petroleum Products"];

export default function EditorialMarquee() {
  return (
    <div
      data-testid="products-marquee"
      className="border-y border-black/10 py-8 sm:py-12 overflow-hidden bg-paper"
    >
      <Marquee speed={22} gradient={false}>
        {ITEMS.map((item) => (
          <span key={item} className="flex items-center shrink-0">
            <span className="font-display font-medium uppercase tracking-tight text-outline text-5xl sm:text-7xl lg:text-8xl px-8 sm:px-12">
              {item}
            </span>
            <span className="text-brand text-xl sm:text-3xl" aria-hidden="true">
              ✦
            </span>
          </span>
        ))}
      </Marquee>
    </div>
  );
}
